<template>
  <div id="filter-modal" class="mt-4">
    <filter-field
      :info.sync="filterParams.interface"
      :items="filterOptions.interfaces"
      label="Interface"
      v-if="_client.client_name !== 'shark'"
    />
    <filter-field
      :info.sync="filterParams.ad_schedule"
      :items="filterOptions.adSchedules"
      label="Ad Schedule"
      v-if="_client.client_name !== 'shark'"
    />
    <filter-field
      :info.sync="filterParams.city"
      :items="filterOptions.cities"
      label="City"
    />
    <filter-field
      :info.sync="filterParams.status"
      :items="filterOptions.active"
      label="Active/Inactive"
    />
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import FilterField from '@/components/filter/FilterField';
import FilterParams from '@/mixins/FilterParams';

export default {
  mixins: [FilterParams],
  components: {
    FilterField,
  },
  methods: {
    ...mapMutations({
      _setFilterOptions: 'filters/setGroupsFilterOptions',
    }),
  },
  computed: {
    ...mapGetters({
      _filterOptions: 'filters/getGroupsFilterOptions',
      _areas: 'areas/getAreas',
      _currentClient: 'account/getCurrentClient',
    }),
    filterOptions: {
      get() {
        return this._filterOptions;
      },
      set() {
        this._setFilterOptions();
      },
    },
  },
};
</script>
